/**
 * Paste-anywhere text for "Share today's front page": the day's masthead line, the top
 * three headlines as a numbered ledger, and one link into the reader. Same growth loop
 * as the quiz grid (a text block travels where images and links get flattened), same
 * house style: no em or en dashes anywhere.
 */

interface HeadlineLike {
  headline?: string | null;
}

export function editionShareText(
  cards: HeadlineLike[],
  dayLabel: string,
  stats: { stories: number; minutes: number },
  url: string,
): string {
  const tops = cards
    .map((c) => String(c.headline || "").trim())
    .filter(Boolean)
    .slice(0, 3)
    .map((h, i) => `${i + 1}. ${h}`);
  return [
    `InSnip, The Daily Edition · ${dayLabel}`,
    ...tops,
    `${stats.stories} stories, about ${stats.minutes} minutes, every story source-checked.`,
    `Read it: ${url}`,
  ].join("\n");
}
